import React from "react";
import PropTypes from "prop-types";

const ModernizedInlineMessage = ({
  field: { image: variant, title: message },
  components: { ModernizedInlineMessage: InlineMessage }
}) => <InlineMessage variant={variant}>{message}</InlineMessage>;

ModernizedInlineMessage.propTypes = {
  field: PropTypes.shape({
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }),
  components: PropTypes.shape({
    ModernizedInlineMessage: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.func
    ])
  })
};

export default ModernizedInlineMessage;
